import { awsApi, baseApi } from 'services/api/base';
import {
  DistributionPlansResponse,
  ProductResponse,
} from 'services/api/responses/responseTypes';
import { environmentManager } from '../config';

const stripeApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getProducts: build.query<Array<ProductResponse>, void>({
      query: () => ({
        url: '/stripe/products',
        params: {
          include_free: true,
          include_enterprise: false,
          include_distribution: true,
        },
      }),
    }),
  }),
});

export const distributionInfo = awsApi.injectEndpoints({
  endpoints: (build) => ({
    getDistributionInfo: build.query<DistributionPlansResponse, void>({
      query: () => {
        const env = environmentManager.isProductionEnv ? 'prd' : 'dev';
        return {
          url: `/distribution/distribution_${env}.json`,
        };
      },
    }),
  }),
});

export default stripeApi;
